import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBlock: 40,
    paddingInline: theme.palette.custom.lgPaddingInline,
    [theme.breakpoints.up('1700')]: {
      paddingInline: theme.palette.custom.xlPaddingInline,
    },
    [theme.breakpoints.down('md')]: {
      paddingInline: theme.palette.custom.smPaddingInline,
    },
    // '& .swiper-slide': {
    //   width: '90px !important',
    // },
  },
  breadcrumbs: {
    '& .MuiTypography-root': {
      [theme.breakpoints.down('sm')]: {
        fontSize: 13,
      },
    },
  },
  productWrapper: {
    display: 'flex',
    paddingBlock: 20,
    flexWrap: 'wrap',
  },
  productImgWrapper: {
    border: '1px solid #eae9e9',
    paddingBlock: 20,
    paddingInline: 8,
  },
  productImgContainer: {
    width: '100%',
    // height: 290,
    [theme.breakpoints.down('md')]: {
      height: 342,
    },
  },
  productImg: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  sliderWrapper: {
    paddingBlock: 12,
    '& .swiper': {
      width: '100%',
    },

    display: 'flex',
    alignItems: 'center',
  },
  imgContainer: {
    minWidth: 85,
    height: 90,
    cursor: 'pointer',
    border: '1px solid #f6b6c1',
  },
  productSlideImg: {
    width: '100%',
    height: '100%',
  },
  tryOnBtn: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingBlockStart: 6,
  },
  contentContainer: {
    paddingInline: 20,
    paddingBlockEnd: 20,
    [theme.breakpoints.down('md')]: {
      paddingBlock: 20,
      paddingInline: 0,
    },
  },
  productName: {
    '& .MuiTypography-root': {
      fontWeight: 600,
      [theme.breakpoints.down('md')]: {
        fontSize: 32,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 24,
      },
    },
  },
  productSubCategoryWrapper: {
    '& .MuiTypography-root': {
      fontWeight: 600,
    },
  },
  productPriceWrapper: {
    display: 'flex',
    gap: 12,
    flexWrap: 'wrap',
    paddingBlockStart: 16,
  },
  productSellingPrice: {
    '& .MuiTypography-root': {
      fontWeight: 600,
    },
  },
  productSkuid: {
    '& .MuiTypography-root': {
      fontWeight: 500,
      color: '#847c7c',
      fontSize: 14,
    },
  },
  productGst: {
    '& .MuiTypography-root': {
      fontWeight: 500,
      color: '#847c7c',
      fontSize: 14,
    },
  },
  productActualPrice: {
    '& .MuiTypography-root': {
      color: 'gray',
      textDecoration: 'line-through',
    },
  },
  productDiscount: {
    '& .MuiTypography-root': {
      color: '#b8292f',
      fontWeight: 600,
    },
  },
  productWeight: {
    display: 'flex',
    alignItems: 'center',
    paddingBlock: 12,
    gap: 12,
    '& .MuiTypography-root': {
      fontWeight: 600,
      paddingBlock: 8,
    },
  },
  autocomplete: {
    width: 70,
    '& .MuiOutlinedInput-root': {
      fontSize: 12,
    },
  },
  productPurity: {
    '& .MuiTypography-root': {
      fontWeight: 600,
      paddingBlock: 8,
    },
  },
  productDetailsLink: {
    '& .MuiTypography-root': {
      paddingBlock: 8,
      textDecoration: 'underline',
      cursor: 'pointer',
      display: 'inline-block',
    },
  },
  appointmentBtn: {
    paddingBlock: 12,
  },
  whatsAppWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  whatsAppNoWrapper: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      color: '#03a503',
      fontSize: 22,
    },
  },
  whatsAppNo: {
    '& .MuiTypography-root': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  featuresWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 12,
    paddingBlock: 8,
  },
  productDetailsContainer: {
    paddingBlock: 5,
  },
  detailsLabel: {
    '& .MuiTypography-root': {
      textAlign: 'center',
      paddingBlockEnd: 20,
    },
  },
  detailsTabelContainer: {
    // paddingBlock: 5,
    // backgroundColor: '#ffeded',
    // paddingInline: 32,
    [theme.breakpoints.down('sm')]: {
      paddingInline: 12,
    },
  },
  title: {
    // paddingBlockEnd: 5,
    [theme.breakpoints.down('sm')]: {
      paddingBlockEnd: 20,
    },
  },
  description: {
    '& .MuiTypography-root': {
      paddingBlockStart: 12,
      paddingBlockEnd: 20,
      [theme.breakpoints.down('sm')]: {
        paddingBlockStart: 0,
      },
    },
  },
  labelWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: 8,
    paddingBlockEnd: 16,
  },
  key: {
    width: 300,
    '& .MuiTypography-root': {
      fontWeight: 600,
    },
    [theme.breakpoints.down('sm')]: {
      width: 120,
    },
  },
  optionList: {
    padding: '3px 10px',
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  activeOptionList: {
    padding: '3px 10px',
    border: "1px solid rgba(0, 0, 0, 0.12)",
    backgroundColor: "rgba(0, 0, 0, 0.12)",
    color: "black",
  },
  value1: {
    // width: 300,
    // [theme.breakpoints.down('sm')]: {
    //   width: 240,
    // },
    '& .MuiTypography-root': {
      textTransform: 'capitalize',
    },
  },
  table: {
    [theme.breakpoints.down('sm')]: {
      width: 'calc(160px + 120px + 120px + 160px + 140px + 180px)',
      overflow: 'auto',
    },
  },
  tableHeaderWrapper: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #d0d0d0',
    paddingBlockEnd: 20,
    [theme.breakpoints.down('sm')]: {
      minWidth: 'calc(160px + 120px + 120px + 160px + 140px + 180px)',
    },
  },
  component: {
    width: 240,
    [theme.breakpoints.down('sm')]: {
      minWidth: 160,
    },
  },
  tableHeaderLabel: {
    '& .MuiTypography-root': {
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        fontSize: 13,
      },
    },
  },
  rate: {
    width: 150,
    [theme.breakpoints.down('sm')]: {
      minWidth: 120,
    },
  },
  weight: {
    width: 180,
    [theme.breakpoints.down('sm')]: {
      minWidth: 120,
    },
  },
  value: {
    width: 240,
    [theme.breakpoints.down('sm')]: {
      minWidth: 160,
    },
  },
  discount: {
    width: 180,
    [theme.breakpoints.down('sm')]: {
      minWidth: 140,
    },
  },
  finalValue: {
    width: 180,
    [theme.breakpoints.down('sm')]: {
      minWidth: 180,
    },
  },
  tableRow: {
    display: 'flex',
    alignItems: 'center',
    paddingBlock: 12,
    '& .MuiTypography-root': {
      [theme.breakpoints.down('sm')]: {
        fontSize: 13,
      },
    },
  },

  // Releative item slider styles

  relRoot: {
    paddingBlock: 70,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      paddingBlock: 50,
    },
  },
  relTitle: {
    '& .MuiTypography-root': {
      textAlign: 'center',
      color: theme.palette.custom.main,
      fontWeight: 600,
      paddingBlockEnd: 28,
      [theme.breakpoints.down('sm')]: {
        fontSize: 28,
      },
    },
  },
  relSliderWrapper: {
    width: '100%',
    // paddingBlockStart: 16,
    paddingInline: theme.palette.custom.lgPaddingInline,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    [theme.breakpoints.up('1700')]: {
      paddingInline: theme.palette.custom.xlPaddingInline,
    },
    [theme.breakpoints.down('md')]: {
      paddingInline: theme.palette.custom.smPaddingInline,
    },
    '& .swiper': {
      width: '100%',
    },
  },
  arrowIcons: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'space-between',
  },
  cardWrapper: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8,
    // width: 198,
    cursor: 'pointer',
    [theme.breakpoints.down('lg')]: {
      width: 160,
    },
    [theme.breakpoints.down('500')]: {
      width: 130,
    },
  },
  relImgContainer: {
    width: '100%',
    height: 188,
    [theme.breakpoints.down('lg')]: {
      height: 150,
    },
    [theme.breakpoints.down('500')]: {
      height: 120,
    },
    transition: 'all 0.3s ease-in-out 0s',
    '&:hover': {
      transform: 'scale(1.03)',
      overflow: 'hidden',
      transition: 'all 0.3s ease-in-out 0s',
    },
  },
  sliderImg: {
    width: '100%',
    height: '100%',
  },
  label: {
    '& .MuiTypography-root': {
      textAlign: 'center',
    },
  },
  tabWrapper: {
    paddingBlock: 8,
    paddingInline: theme.palette.custom.lgPaddingInline,
    [theme.breakpoints.up('1700')]: {
      paddingInline: theme.palette.custom.xlPaddingInline,
    },
    [theme.breakpoints.down('md')]: {
      paddingInline: theme.palette.custom.smPaddingInline,
    },
    '& .MuiTab-root': {
      marginInlineEnd: 20,
      textTransform: 'capitalize',
      fontSize: 17,
      fontWeight: 500,
      transition: 'all ease .3s',
      border: '1px solid #022247',
      borderRadius: 10,
      minHeight: 32,
      padding: '6px 24px',
    },
    '& .MuiTabs-indicator': {
      height: 0,
    },
    '& .Mui-selected': {
      color: '#ffffff !important',
      backgroundColor: theme.palette.custom.main,
    },
  },
  emptyData: {
    '& .MuiTypography-root': {
      paddingBlock: 12,
      textAlign: 'center',
    },
  },
}))

export default useStyles
